import { render, staticRenderFns } from "./SankeyBiome.vue?vue&type=template&id=190fdf1f&"
import script from "./SankeyBiome.vue?vue&type=script&lang=js&"
export * from "./SankeyBiome.vue?vue&type=script&lang=js&"
import style0 from "./SankeyBiome.vue?vue&type=style&index=0&id=190fdf1f&prod&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports